import styled from 'styled-components';

export const BaseInfoSC = styled.div`
  display: flex;
  align-items: stretch;

  p {
    font-weight: bold;
    opacity: 0.4;
    font-size: 14px;
    margin-bottom: 0;
  }

  .bi-avatar-btn {
    margin-top: 18px;
    width: 290px;
    font-size: 14px;
    height: 30px;
    text-transform: uppercase;
    background-color: rgba(106, 213, 229, 1);
  }

  .bi-avatar-col {
    width: auto;

    /* min-width: 323px; */

    /*     height: 240px; */
    border-right: 2px solid #fff;
    text-align: center;
    padding: 24px;

    h1 {
      font-size: 20px;
      font-weight: bold;
      line-height: 1.5;
      margin: 10px 0 0 0;
    }

    .info-datas {
      padding-left: 16px;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }
    .info-indicators {
      width: 64px;
      min-width: 64px;
      height: 30px;
      padding: 5px;
      margin-top: 5px;
      background: white;
      border-radius: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &__call {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 22px;
        height: 22px;
        background: #d6d8e2;
        border-radius: 100%;
      }
      &__video {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 22px;
        height: 22px;
        background: #d6d8e2;
        border-radius: 100%;
        &.active {
          background: #16e208;
        }
      }
    }
  }

  .bi-info-col {
    width: 66.6666%;
    padding: 24px;

    h2 {
      font-weight: 600;
      margin-bottom: 0;
      font-size: 16px;
      line-height: 1.25;
      opacity: 0.6;
    }
  }

  .bi-list {
    display: flex;
    align-items: center;
    margin-top: 8px;
    flex-wrap: wrap;
    font-size: 14px;
    font-weight: 800;

    &__health-data {
      width: 100%;
      max-width: 400px;

      > div {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;

        > div {
          width: 100%;
          max-width: 180px;

          > span:first-child {
            margin-right: 8px;
          }

          > span:not(:first-child) {
            font-weight: 400;
          }
        }
      }
    }
  }
`;
